import { Component, HostListener } from '@angular/core';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas'
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IpdchartService } from 'src/app/private/services/ipdchart.service';
import { TemplateService } from 'src/app/private/services/template.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import { IpdAppointmentService } from 'src/app/private/services/ipdappointment.service';

@Component({
  selector: 'app-discharge-summery',
  templateUrl: './discharge-summery.component.html',
  styleUrls: ['./discharge-summery.component.scss']
})
export class DischargeSummeryComponent {
  private dischargeModalRef: NgbModalRef | null = null;
  hospital_logo: any = localStorage.getItem("getBase64logo");
  current_patient_id: any;
  ipd_app_id: any;
  btnSaveLoading: boolean = false;
  dischargeDetailObject: any;
  dischargeDate:any;
  btnLoadingDischarge: boolean = false;
  constructor(private toast: ToastrService, private appointment: IpdAppointmentService, private modalService: NgbModal, public route: ActivatedRoute, private ipdChartData: IpdchartService, private templateService: TemplateService, private LocalStorage: LocalStorageService) {
    this.route.params.subscribe(params => {
      this.current_patient_id = params['id']
      this.ipd_app_id = params['ipd_app_id']
    })
  }

  ngAfterViewInit() {
    this.getDischargeDetail();
  }
  async getDischargeDetail() {

    let param = {

      hospital_id: this.LocalStorage.getHospitalId(),
      center_id: this.LocalStorage.getCenterId(),
      patient_id: this.current_patient_id,
      id: this.ipd_app_id,
    }
    this.ipdChartData.getDischargeDetails(param).subscribe({
      next: (res) => {
        if (res) {
          this.dischargeDetailObject = res;
          if(!this.hospital_logo) {
            this.convertImageUrlToBase64(res.logo, (base64:any) =>{
                      this.hospital_logo = base64;
                  });
          }
        //   this.convertImageUrlToBase64(res.logo, (base64:any) =>{
        //     this.hospital_logo = base64;
        // });
        }
      },
      error: (e) => {

      }
    })

  }

  async changeDischarge(dischargeAppointment:any) {
    this.dischargeDate = `${this.dischargeDetailObject?.date_of_discharge}T${this.dischargeDetailObject?.time_of_discharge}`;
    this.dischargeModalRef = this.modalService.open(dischargeAppointment,   { size:'sm', scrollable: false,backdrop: 'static',ariaLabelledBy: 'modal-basic-title' });
  }

  changedate() {
    this.btnLoadingDischarge = true;
    console.log(" new date : ",this.dischargeDate);
    const [date, time] = this.dischargeDate.split("T");

    console.log("Date:", date); // Output: 2025-03-21
    console.log("Time:", time); // Output: 18:11
    let param = {
      hospital_id: this.LocalStorage.getHospitalId(),
      center_id: this.LocalStorage.getCenterId(),
      patient_id: this.current_patient_id,
      id: this.ipd_app_id,
      date_of_discharge: date,
      time_of_discharge: time,
      status: "discharge",
    }
    this.appointment.updateIpdAppointment(param).subscribe({
      next: (res) => {
        if (res) {
          this.toast.success("Discharged date updated ")
          this.dischargeDetailObject.date_of_discharge = date;
          this.dischargeDetailObject.time_of_discharge = time;
          this.btnLoadingDischarge = false;
        }
        else {
          this.btnLoadingDischarge = false;
        }
        this.dischargeModalRef?.close();
      },
      error: (e) => {
        console.log(e)
      }
    })
  }

  async getImageFromCanvas(page: any) {
    const canvas = await html2canvas(page);
    console.log(canvas);
    return canvas.toDataURL("image/png", 1.0);;
  }

  async convertImageUrlToBase64(imageUrl:any, callback:any) {
    const img = new Image();
    img.crossOrigin = "Anonymous"; // Prevents CORS issues
    img.src = imageUrl;

    img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx:any = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        const base64String = canvas.toDataURL("image/png"); // Convert to Base64
        callback(base64String);
    };

    img.onerror = function () {
        console.error("Error loading image");
        callback(null);
    };

  
}


  getDimensionPage(doc: any, image: any) {
    let bufferX = 5;
    const bufferY = 5;
    const imgProps = (<any>doc).getImageProperties(image);
    const pdfWidth = doc.internal.pageSize.getWidth() - 2 * bufferY;
    const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    const type = "PNG";
    const compression = 'FAST';
    return { image, type, bufferX, bufferY, pdfWidth, pdfHeight, undefined, compression }
  }
  async printPage() {
    this.btnSaveLoading = true;
    const discharge_summery = document.getElementById('discharge_summery') as HTMLElement;
    const treatment_plan = document.getElementById('treatment_plan') as HTMLElement;
    const excludeElement = document.getElementById('editDischarge') as HTMLElement; 
    if (excludeElement) excludeElement.style.display = 'none';
    const doc = new jsPDF();
    var discharge_summery_image: any = await this.getImageFromCanvas(discharge_summery);
    var treatment_plan_image: any = await this.getImageFromCanvas(treatment_plan);
    if (excludeElement) excludeElement.style.display = '';
    const param: any = this.getDimensionPage(doc, discharge_summery_image);
    const paramTreatment: any = this.getDimensionPage(doc, treatment_plan_image);

    console.log(param.pdfHeight);
    doc.addImage(param.image, param.type, param.bufferX, param.bufferY, param.pdfWidth, param.pdfHeight, undefined, param.compression);

    doc.addPage();
    doc.addImage(paramTreatment.image, paramTreatment.type, paramTreatment.bufferX, paramTreatment.bufferY, paramTreatment.pdfWidth, paramTreatment.pdfHeight, undefined, paramTreatment.compression);
    var pdfUrl = URL.createObjectURL(doc.output('blob'));
    window.open(pdfUrl, "_blank")?.print();
    this.btnSaveLoading = false;

    // doc.addPage();



  }
  exportAllToPDF(pages: HTMLElement) {



    // doc.html(pages, {
    //   callback: (doc: jsPDF) => {
    //     var pdfUrl = URL.createObjectURL(doc.output('blob'));
    //     let newWindow = window.open(pdfUrl, "_blank")?.print();


    //   },x: 10,
    //   y: 10
    // });
  }
}
